import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { AddResultModalProps } from "../api/Dtos";
import { useGlobalContext } from "../Layout/GlobalState";

const AddResultModal: React.FC<AddResultModalProps> = ({
  isOpen,
  onClose,
  onAddRow,
}) => {
  const globalContext = useGlobalContext();
  const [finishTime, setFinishTime] = useState("");
  const [startnumber, setStartnumber] = useState("");

  const [parsedDate, setParsedDate] = useState<Date | null>(null);

  useEffect(() => {
    if (globalContext.competition?.startTime) {
      setParsedDate(
        applyTimeToDate(
          new Date(globalContext.competition.startTime),
          finishTime
        )
      );
    }
  }, [globalContext.competition?.startTime, finishTime]);

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    console.info("finishTime: " + finishTime + ", startnumber: " + startnumber);
    onAddRow({
      finishTime: parsedDate!.getTime(),
      startnumber: parseInt(startnumber),
    });
    setFinishTime("");
    setStartnumber("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Lägg till löpare i resultatlistan</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <form onSubmit={handleSubmit}>
            <FormControl
              id="finishTime"
              isRequired
              isInvalid={parsedDate == null}
            >
              <FormLabel>Klockslag vid målgång</FormLabel>
              <Input
                type="text"
                placeholder="HH:mm:ss.[ms] (13:45:02.123)"
                value={finishTime}
                onChange={(e) => {
                  setFinishTime(formatProgressiveTime(e.target.value));
                }}
              />
            </FormControl>
            <FormControl id="startnumber" isRequired>
              <FormLabel>Löparens startnummer</FormLabel>
              <Input
                type="text"
                value={startnumber}
                onChange={(e) =>
                  setStartnumber(e.target.value.replace(/\D/g, ""))
                }
              />
            </FormControl>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSubmit}
            isDisabled={parsedDate == null || startnumber.trim().length === 0}
          >
            Lägg till löpare
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Avbryt
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

function formatProgressiveTime(input: string): string {
  const digits = input.replace(/\D/g, "").slice(0, 9);
  const len = digits.length;

  if (len <= 2) {
    return digits; // H, HH
  }

  if (len <= 4) {
    return `${digits.slice(0, len - 2)}:${digits.slice(-2)}`; // H:MM, HH:MM
  }

  if (len <= 6) {
    return `${digits.slice(0, len - 4)}:${digits.slice(
      len - 4,
      len - 2
    )}:${digits.slice(-2)}`; // H:MM:SS, HH:MM:SS
  }

  // 7-9 digits => HH:MM:SS.m, HH:MM:SS.mm, HH:MM:SS.mmm
  return `${digits.slice(0, 2)}:${digits.slice(2, 4)}:${digits.slice(
    4,
    6
  )}.${digits.slice(6)}`;
}

function applyTimeToDate(baseDate: Date, timeString: string): Date | null {
  const parts = timeString.split(":");
  if (parts.length !== 3) return null;

  const hh = Number(parts[0]);
  const mm = Number(parts[1]);
  const [ssPart, msPart] = parts[2].split(".");
  const ss = Number(ssPart);

  if (msPart !== undefined && (msPart.length === 0 || msPart.length > 3)) {
    return null;
  }

  const ms =
    msPart === undefined ? 0 : Number(msPart.padEnd(3, "0"));

  const isValid =
    Number.isInteger(hh) &&
    hh >= 0 &&
    hh <= 23 &&
    Number.isInteger(mm) &&
    mm >= 0 &&
    mm <= 59 &&
    Number.isInteger(ss) &&
    ss >= 0 &&
    ss <= 59 &&
    Number.isInteger(ms) &&
    ms >= 0 &&
    ms <= 999;

  if (!isValid) return null;

  const newDate = new Date(baseDate);
  newDate.setHours(hh, mm, ss, ms);
  return newDate;
}

export default AddResultModal;
